import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../i18n/translations';

export const PrivacyPolicy: React.FC = () => {
    const { language } = useLanguage();

    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {/* Header with back link */}
                <div className="mb-8">
                    <Link 
                        to="/" 
                        className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        {language === 'ru' ? 'На главную' : 'Back to home'}
                    </Link>
                </div>

                {/* Title */}
                <h1 className="text-4xl sm:text-5xl font-semibold mb-8 leading-tight" style={{ color: '#324966' }}>
                    {t('privacy.title', language) as string}
                </h1>

                {/* Last updated date */}
                <p className="text-sm text-gray-500 mb-12">
                    {t('privacy.lastUpdated', language) as string}
                </p>

                {/* Content */}
                <div className="prose prose-lg max-w-none">
                    <div className="text-gray-700 leading-relaxed space-y-6 mb-12">
                        {(t('privacy.content', language) as string[]).map((paragraph, index) => (
                            <p key={index} className="mb-4">
                                {paragraph}
                            </p>
                        ))}
                    </div>

                    {/* Sections */}
                    {(t('privacy.sections', language) as any[]).map((section, index) => (
                        <div key={index} className="mt-10">
                            <h2 className="text-2xl font-semibold mb-6 mt-10" style={{ color: '#324966' }}>
                                {section.title}
                            </h2>
                            {section.items && section.items.map((item: any, itemIndex: number) => (
                                <div key={itemIndex} className="mb-6">
                                    <p className="text-gray-700 leading-relaxed mb-2">
                                        {item.title && (
                                            <>
                                                <span className="font-semibold text-gray-900">
                                                    {item.title}
                                                </span>
                                                {' '}
                                            </>
                                        )}
                                        {item.content}
                                    </p>
                                    {item.subitems && (
                                        <ul className="ml-6 mt-2 space-y-2">
                                            {item.subitems.map((subitem: any, subIndex: number) => (
                                                <li key={subIndex} className="text-gray-700 leading-relaxed list-disc">
                                                    {subitem}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                {/* Footer link */}
                <div className="mt-12 pt-8 border-t border-gray-200">
                    <Link 
                        to="/" 
                        className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        {language === 'ru' ? 'На главную' : 'Back to home'}
                    </Link>
                </div>
            </div>
        </div>
    );
};
